import { getMinCosts } from './minCosts'

export default {
  ...getMinCosts
}
